import React from 'react';
import './estilo.scss';
import 'materialize-css/dist/css/materialize.min.css'
import { FaGraduationCap } from 'react-icons/fa';



function Biography() {
    const parag = [
        "I am a professional who has always been concerned with learning about new areas and technologies in IT. With a little more than 10 years of experience in different companies and different areas, I have accumulated experience in different segments such as banks, technology companies and large consultancies.",
        "I started working with IT in 2010, my life as a developer begin in 2018.",
        "Mostly working with javascript + Node, Java and AngularJS(legacy system). No idea which stack i'll be using tomorrow, you tell me. My main interests are chatbots and data science.",
        "I always seek to acquire new knowledge, I love to learn new things, even something I already know in a different way."
    ]
    const interests = [
        "Chatbots",
        "Data Science",
        "UI Design",
        "Mobile"
    ]
    const education = {
        list:
            [
                {
                    course: "Computer Engineering, 2018",
                    institution: "FIAP - São Paulo, Brazil"
                }
            ]
    }
    return (
        <section id="aboutme" className="biography-container container">
            <div className="biography-title-container">
                {parag.map((parag, index) => {
                    return <p key={index} className="biography-title-resume">{parag}</p>
                })
                }
            </div>
            <div className="interest-education-box">
                <div className="interest-education">
                    <h3 className="interest-education-title">Interests</h3>
                    <ul>
                        {interests.map((item, index) => {
                            return <li className="interest-education-item" key={index}>{item}</li>
                        })}
                    </ul>
                </div>
                <div className="interest-education">
                    <h3 className="interest-education-title">Education</h3>
                    <ul>
                        {education.list.map((item, index) => {
                            return <li className="interest-education-item-icon">
                                <FaGraduationCap className="interest-education-item-icon-size"/>
                                <div key={index} >
                                    <p className="interest-education-item-title interest-education-item">{item.course}</p>
                                    <p className="interest-education-item">{item.institution}</p>
                                </div>
                            </li>

                        })}
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default Biography;